<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="800">
    <v-card v-if="row != null">
      <OperationDialogTitle v-bind="row" @close="dismiss" />

      <v-card-text class="pa-3">
        <v-form
          ref="theForm"
          v-model="isValid"
          class="d-flex flex-wrap items-start"
        >
          <!-- opcional, pois podemos mover módulos antes de estarem associados -->
          <OAutocomplete
            :readonly="readonly"
            class="w-2/3 pa-3"
            v-model="row.vehicleId"
            label="Veículo"
            placeholder="Selecione..."
            :items="vehicles"
          />

          <ODateTimeInput2
            :readonly="readonly"
            class="w-1/3 pa-3"
            label="Data/hora"
            v-model="row.timestamp"
            :clearable="false"
          />

          <div class="d-flex items-start w-full">
            <div class="d-flex grow-1">
              <OAutocomplete
                :readonly="readonly"
                class="pa-3 w-1/2"
                v-model="row.fromDepotId"
                label="Estoque de origem"
                placeholder="Selecione..."
                :items="depots"
                :rules="[isSet]"
              />

              <OAutocomplete
                :readonly="readonly"
                class="pa-3 w-1/2"
                v-model="row.toDepotId"
                label="Estoque de destino"
                placeholder="Selecione..."
                :items="depots"
                :rules="[isSet]"
              />
            </div>
          </div>

          <OTextarea
            :readonly="readonly"
            class="w-full pa-3"
            label="Comentários"
            v-model="row.comments"
            :rows="2"
            filled
          />

          <RowDates class="ma-3" :value="row" />
        </v-form>
      </v-card-text>
      <ODialogButtons
        class="pa-4"
        txtApply="Salvar"
        @apply="apply"
        @cancel="dismiss"
      />
    </v-card>
  </ODialog>
</template>

<script>
import TheUser from 'oderon-vue/auth/TheUser'
import RowDates from './RowDates.vue'
import { ClientHistory, Depot } from '../../../models'
import {
  postOrPatch,
  fetchVehiclesOfInterest,
  splitAndSort,
  findActiveInstall,
  canEdit
} from './operation-utils'
import { isSet } from 'oderon-vue/utils.js'
import OperationDialogTitle from './OperationDialogTitle.vue'

export default {
  components: { RowDates, OperationDialogTitle },
  data() {
    let start = this.reset()
    return {
      ...start,
      isSet,
      TheUser
    }
  },
  computed: {
    readonly() {
      return this.row && this.row.id && !canEdit(this.TheUser)
    }
  },
  methods: {
    reset() {
      return {
        isValid: false,
        row: null
      }
    },

    async open({ clientId, historyId }) {
      Object.assign(this, this.reset())

      if (this.$refs.theForm) this.$refs.theForm.resetValidation()

      this.$refs.dialog.$loading(() => this.fetchAll(clientId, historyId))

      return this.$refs.dialog.$open()
    },

    async fetchAll(clientId, historyId) {
      let allDepots = await Depot.findAll()
      this.depots = splitAndSort(allDepots)

      this.vehicles = await fetchVehiclesOfInterest(clientId)
      if (historyId == null) {
        let activeInstall = await findActiveInstall(clientId)
        this.row = {
          type: 'logistic',
          timestamp: new Date(),
          clientId: clientId,
          vehicleId: activeInstall && activeInstall.vehicleId
        }
      } else {
        this.row = await ClientHistory.findById(historyId)
      }
    },

    apply() {
      if (this.$refs.theForm.validate()) {
        this.$refs.dialog.$loading(async () => {
          await postOrPatch('/clients/:cid/logistic', this.row)
          this.$snack('Registro salvo com sucesso')
          this.$refs.dialog.$apply('RELOAD')
        })
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
